import React, { useState } from "react";
import { Link } from "react-router-dom";
import clsx from "clsx";
import {
  FaChevronRight,
  FaRegCircle,
  FaChevronDown,
} from "react-icons/fa";
import {
  TbSmartHome,
  TbBrowser,
  TbAward,
  TbBook2,
  TbColorSwatch,
  TbBrandTabler,
} from "react-icons/tb";
import { MdOutlineSportsFootball } from "react-icons/md";
import { LiaIdCardSolid } from "react-icons/lia";
import { CgComponents } from "react-icons/cg";
import { LuCircleDot } from "react-icons/lu";
import { MdCircle } from "react-icons/md";
import { PiArmchair,PiPhoneOutgoing } from "react-icons/pi";

export default function Sidebar() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [submenuState, setSubmenuState] = useState({});

  const toggleSidebar = () => setIsCollapsed(!isCollapsed);

  const toggleSubmenu = (menu) => {
    setSubmenuState((prevState) => ({
      ...prevState,
      [menu]: !prevState[menu],
    }));
  };

  const sidebarWidth = ""

  const menus = [
    {
      label: "Home Page",
      icon: <TbBrowser className="w-6 h-6" />,
      submenu: [
        { label: "Slider Management", link: "/sab/sliderManagement" },
        { label: "Welcome Section Management", link: "/sab/welcome-section" },
        { label: "Partners/ Accreditations Management", link: "/sab/partners-accreditations-management" },
        { label: "Gallery Management", link: "/sab/gallery-management" },
        { label: "Popup Banner", link: "/sab/popup-banner" },
      ],
    },
    {
      label: "About Us",
      icon: <LiaIdCardSolid className="w-6 h-6" />,
      submenu: [
        { label: "About SAB Campus", link: "/aboutus/vision" },
        { label: "Council", link: "/aboutus/council" },
        { label: "Board of Management", link: "/aboutus/boardOfManagement" },
        { label: "Board of Studies", link: "/aboutus/boardOfStudies" },
      ],
    },
   
    {
      label: "Academics & International",
      icon: <TbBook2 className="h-8 w-7" />,
      submenu: [
        { label: "Department Management", link: "/academics&international/departmentManagement/department" },
        { label: "Degree Management", link: "/academics&international/degreeManagement/addDegree" },
        { label: "Applications", link: "/academics&international/applications" },
        { label: "International Section", link: "/academics&international/international/addProgram" },
        { label: "Interest Free Loan Scheme", link: "/academics&international/loanScheme/addLoan" },
        { label: "Scholarships", link: "/academics&international/scholarships/addScholarship" },
        { label: "Training Partners", link: "/sab/training-partners" },
        { label: "Center for Quality Assurance (CQA)", link: "/gallery&News/cqa-description" },
      ],
    },
    {
      label: "Student Support",
      icon: <TbBrandTabler className="w-6 h-6" />,
      submenu: [
        { label: "Flyer Section and Careers", link: "/sab/career" },
        { label: "Service Menu", link: "/it-services/service-menu" },
        { label: "Student Counsellor", link: "/it-services/student-counsellor" },
      
      ],
    },
    // {
    //   label: "Career",
    //   icon: <PiArmchair className="w-6 h-6" />,
    //   submenu: [
     
        
    //   ],
    // },
    {
      label: "Research & Publications",
      icon: <TbColorSwatch className="w-6 h-6" />,
      submenu: [
        {
          label: "Research",
          submenu: [
            { label: "SAB SRC", link: "/sab/sab-src" },
            { label: "Research Publications", link: "/sab/research-publications" },
            //  { label: "Student Life", link: "/sab/student-life" },            
            // { label: "Student Events", link: "/sab/student-events" }, 
            // { label: "Student Sports", link: "/sab/student-sports" }, 
            
            // { label: "Career Guidance & Internships", link: "/sab/careerGuidance-internships" }, 
             
          ],
        },
        // {
        //   label: "Student Life",
        //   submenu: [
          
        //     // { label: "Sports", link: "/events" },
        //     // { label: "Career Guidance & Internships", link: "/events" },
        //     { label: "Clubs and Societies", link: "/sab/student-life" },            
        //     { label: "Student Events", link: "/sab/student-events" }, 
        //     { label: "Student Sports", link: "/sab/student-sports" }, 
            
             
        //   ],
        // },
      ],
    },
    {
      label: "Student Life",
      icon: <MdOutlineSportsFootball className="w-6 h-6" />,
      submenu: [
        { label: "Clubs and Societies", link: "/sab/student-life" },
        { label: "Student Events", link: "/sab/student-events" },
        { label: "Student Sports", link: "/sab/student-sports" },
        { label: "CSR Projects", link: "/sab/csr-projects" },

      ],
    },
    {
      label: "Gallery & News",
      icon: <CgComponents className="w-6 h-6" />,
      submenu: [
        { label: "Gallery", link: "/gallery&News/news-gallery-management" },
        { label: "Video Gallery", link: "/gallery&News/video-gallery" },
        { label: "News", link: "/gallery&News/add-news" },
       
        
      ],
    },
    {
      label: "Alumni",
      icon: <TbAward className="w-6 h-6" />,
      submenu: [
        { label: "About Alumni", link: "/sab/about-alumni" },
        { label: "Alumni Latest News", link: "/sab/alumni-news" },
        { label: "Alumni Gallery", link: "/sab/alumini-gallery"},
        { label: "Alumni Directory", link: "/sab/alumini-directory"},
        { label: "Alumni Registration", link: "/sab/alumni-registration"},
        { label: "Intakes", link: "/sab/intakes"},
        
       
      ],
    },
   
   
    {
      label: "Contact Us",
      icon: <PiPhoneOutgoing className="w-6 h-6" />,
      submenu: [
        { label: "Contact Information", link: "/contact-us/contact-information" },
        { label: "Inquiry", link: "/contact-us/inquiry" },
      ]
    },
  ];

  return (
    <div
      className={clsx(
        "min-h-screen bg-sidebar-color text-white transition-all overflow-y-auto sidebar-container",
        sidebarWidth
      )}
    >
      {/* Sidebar Header */}
      <div className="flex items-center justify-between px-4 py-4">
      <h1 className={clsx("text-lg font-bold flex items-center gap-2", isCollapsed ? "hidden" : "block")}>
  {/* Rectangle with circle */}
  <div className="relative flex items-center ml-1 mr-1">
    {/* Rectangle */}
    <div className="h-5 w-2 bg-[#8B2B8F]"></div>
    {/* Circle positioned at the bottom of the rectangle */}
    <div className="absolute bottom-0 w-2 h-2 transform -translate-x-1/2 bg-white rounded-full left-1/2"></div>
  </div>
  {/* Text */}
  <span>SAB CAMPUS</span>
</h1>

        {/* <button onClick={toggleSidebar} className="text-gray-400 hover:text-white">
          <LuCircleDot /> 
        </button> */}
      </div>

      {/* Sidebar Links */}
      <button
        className={clsx(
          "flex items-center w-full gap-2 px-4 py-2 transition rounded-lg hover:bg-[#D086CD1A] hover:bg-opacity-10",
          { "justify-center": isCollapsed }
        )}
        // onClick={() => (window.location.href = "/")}
      >
        <TbSmartHome className="w-6 h-6" />
        {!isCollapsed && (
          <>
            Dashboard<span className="ml-auto"> </span>
          </>
        )}
      </button>
      
      {!isCollapsed && (<div className="py-2 px-4 text-[#D086BB] text-xs">APPLICATION</div>)}
      <div className="px-4">
        {menus.map((menu, index) => (
          <div key={index}>
            <button
              className="flex items-center w-full gap-2 px-1 py-2 transition rounded-lg hover:bg-[#D086CD1A] hover:bg-opacity-10 text-left"
              onClick={() => (menu.submenu ? toggleSubmenu(menu.label) : null)}
            >
              {menu.icon}
              {!isCollapsed && <span>{menu.label}</span>}
              {menu.submenu && !isCollapsed && (
                <span className="ml-auto">
                  {submenuState[menu.label] ? <FaChevronDown /> : <FaChevronRight />}
                </span>
              )}
            </button>

            {menu.submenu && submenuState[menu.label] && (
  <div className="pl-8 mt-2 space-y-2">
    {menu.submenu.map((submenu, subIndex) =>
      submenu.submenu ? (
        <div key={subIndex}>
          <button
            className={clsx(
              "flex items-center gap-2 py-2 text-white transition rounded-lg hover:bg-[#D086CD1A] hover:text-white",
              { "justify-center pl-0": isCollapsed }
            )}
            onClick={() => toggleSubmenu(submenu.label)}
          >
            {!isCollapsed && <FaRegCircle className="inline w-3 h-3" />}
            {!isCollapsed && submenu.label}
            {!isCollapsed && (
              <span className="ml-auto">
                {submenuState[submenu.label] ? (
                  <FaChevronDown />
                ) : (
                  <FaChevronRight />
                )}
              </span>
            )}
          </button>
          {submenuState[submenu.label] && (
            <div className="mt-2 space-y-2">
              {submenu.submenu.map((subsubmenu, subsubIndex) => (
                <Link
                  key={subsubIndex}
                  to={subsubmenu.link}
                  className={clsx(
                    "block py-2 text-white hover:text-white",
                    { "pl-2": isCollapsed }
                  )}
                >
                  {!isCollapsed && (
                    <MdCircle className="inline w-3 h-3 mr-2" />
                  )}
                  {!isCollapsed && subsubmenu.label}
                </Link>
              ))}
            </div>
          )}
        </div>
      ) : (
        <Link
          key={subIndex}
          to={submenu.link}
          className={clsx(
            "block py-2 text-white hover:text-white",
            { "pl-2": isCollapsed }
          )}
        >
          {!isCollapsed && <FaRegCircle className="inline w-3 h-3 mr-2" />}
          {!isCollapsed && submenu.label}
        </Link>
      )
    )}
  </div>
)}

          </div>
        ))}
      </div>
    </div>
  );
}
